// extracted by mini-css-extract-plugin
module.exports = {"close":"close__+6UbH","icon":"icon__yz04r"};